import {h, Fragment} from "preact"
import { useAppState, AutocompleteElement, Keywords } from "@nosto/preact"
import { formatCurrency, productImagePlaceholder } from "../helpers"

export default function () {
    const { response: { products, keywords }, query } = useAppState()

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }
    
    return (
        <div
            class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
        >

            <div class="ns-d-flex ns-flex-column ns-w-100">
                {keywords?.hits?.length > 0 && (
                    <div
                        class="ns-autocomplete-keywords ns-w-100 ns-d-flex ns-flex-column"
                    >
                        <div class="ns-d-flex ns-flex-column">
                            {keywords?.hits?.map((hit) => {
                                return (
                                    <AutocompleteElement hit={hit}>
                                        <div
                                            class="ns-clickable ns-font-5"
                                            data-nosto-element="keyword"
                                        >
                                            {
                                                hit?._highlight?.keyword
                                                    ? <span dangerouslySetInnerHTML={{ __html: hit._highlight.keyword }}></span>
                                                    : <span>{hit.keyword}</span>
                                            }
                                        </div>
                                    </AutocompleteElement>
                                )
                            })}
                            {/* <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                /> */}
                        </div>
                    </div>
                )}
                {products?.hits?.length > 0 && (
                    <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                        <div class="ns-d-flex ns-flex-column">
                            {products?.hits?.map(hit => {

                                const { url, name, imageUrl, price, listPrice } = hit;

                                return (
                                    <AutocompleteElement hit={hit}>
                                        <div
                                            data-url={url}
                                            class="ns-d-flex ns-align-items-center flex-row ns-clickable"
                                            data-nosto-element="product"
                                        >
                                            <a href="javascript:void(0)">
                                                <img
                                                    class="ns-h-auto ns-object-contain"
                                                    src={
                                                        imageUrl ??
                                                        productImagePlaceholder
                                                    }
                                                    alt={name}
                                                    width="50"
                                                    height="50"
                                                />
                                            </a>
                                            <div class="ns-pl-2">
                                                <div class="ns-font-4 ns-clipped ns-text-one-line">
                                                    {name}
                                                </div>
                                            </div>
                                        </div>
                                    </AutocompleteElement>
                                )
                            })}
                            <SubmitButton query={query} />
                        </div>
                    </div>
                )}
            </div>

        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword,
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, filter }) {
    return (
        <AutocompleteElement
            hit={hit}
            filter={filter}
            class="ns-clickable ns-py-2 ns-px-4 ns-font-4"
        >
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({
    category,
    children,
}) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}

function SubmitButton({ query }) {

    return (
        <div class="ns-autocomplete-submit ns-d-flex ns-justify-content-center">
            <button
                type="submit"
                class="ns-act-btn ns-text-align-center"
            >
                All results for "{query.query}"
            </button>
        </div>
    )
}
